import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  StyleProp,
  View,
  ViewStyle,
  Image,
  TouchableOpacity,
  StyleSheet,
  TouchableWithoutFeedback,
  Text,
  FlatList,
  ImageStyle,
  ImageBackground,
} from "react-native";
import { colors } from "../common/styles/colors";
import { ArrowLight } from "../common/icons/ArrowLight";

export const PhotoCarousel = ({
  style,
  containerStyle,
  overlay = false,
  data,
}: {
  style?: StyleProp<ViewStyle>;
  containerStyle?: StyleProp<ViewStyle>;
  overlay?: boolean;
  data: string[];
}) => {
  const [currentPosition, setCurrentPosition] = useState(0);

  const [containerHeight, setContainerHeight] = useState(0);

  const ref = useRef<FlatList>(null);

  //Todo: remake currentPosition into ref value, add animations

  const [scrollContainerWidth, setScrollContainerWidth] = useState<number>(0);

  useEffect(() => {
    setCurrentPosition(0);
  }, [data]);

  useEffect(() => {
    if (data.length > 0) {
      ref.current?.scrollToIndex({
        index: currentPosition,
      });
    }
  }, [currentPosition, data.length]);

  return (
    <View
      onLayout={(event) => setContainerHeight(event.nativeEvent.layout.height)}
      style={[style, { position: "relative" }]}
    >
      <FlatList
        data={data}
        renderItem={({ item, index }) => (
          <TouchableOpacity
            activeOpacity={1}
            onPress={() => {
              setCurrentPosition(index !== data.length - 1 ? index + 1 : 0);
            }}
            key={index}
          >
            <ImageBackground
              style={[
                {
                  width: scrollContainerWidth,
                  aspectRatio: 1,
                },
              ]}
              source={{ uri: item }}
            >
              {overlay && (
                <View
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    backgroundColor: colors.black,
                    zIndex: 1,
                    opacity: 0.2,
                  }}
                />
              )}
            </ImageBackground>
          </TouchableOpacity>
        )}
        ref={ref}
        scrollEnabled={false}
        horizontal
        onLayout={(e) => setScrollContainerWidth(e.nativeEvent.layout.width)}
        style={[styles.pagerView, containerStyle]}
      />

      {currentPosition !== 0 && (
        <TouchableOpacity
          style={[
            styles.arrowContainer,
            { top: containerHeight / 2 - 30, left: 8 },
          ]}
          onPress={() => setCurrentPosition((prevState) => prevState - 1)}
        >
          <ArrowLight
            style={[
              { transform: [{ rotate: "180deg" }] },
              styles.arrow,
              { left: 12 },
            ]}
          />
        </TouchableOpacity>
      )}

      {currentPosition !== data.length - 1 && (
        <TouchableOpacity
          style={[
            styles.arrowContainer,
            { top: containerHeight / 2 - 30, right: 8, alignItems: "flex-end" },
          ]}
          onPress={() => setCurrentPosition((prevState) => prevState + 1)}
        >
          <ArrowLight style={[styles.arrow, { right: 12 }]} />
        </TouchableOpacity>
      )}

      {data.length > 1 && (
        <View style={styles.pagingContainer}>
          {data.map((item, index) => (
            <View
              key={index}
              style={[
                { opacity: index === currentPosition ? 1 : 0.4 },
                styles.pagingIndicator,
              ]}
            />
          ))}
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  pagerView: {
    height: "100%",
    width: "100%",
    zIndex: 0,
    aspectRatio: 1,
    borderRadius: 12,
    overflow: "hidden",
  },
  pagingIndicator: {
    height: 4,
    flex: 1,
    backgroundColor: colors.LightGrayishYellow,
    borderRadius: 4,
    marginHorizontal: 4,
    elevation: 4,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.6,
    shadowRadius: 4,
  },
  pagingContainer: {
    width: "100%",
    flexDirection: "row",
    paddingHorizontal: 8,
    position: "absolute",
    bottom: 8,
  },
  withOpacity: { backgroundColor: "white", opacity: 0.4, zIndex: 10 },
  arrow: {
    elevation: 4,
  },
  arrowContainer: {
    position: "absolute",
    width: 60,
    height: 60,
    justifyContent: "center",
  },
});
